<ng-container *ngIf="portalLead$ | async as portalLead">
  <ng-container *ngIf="portalLead.salesAgent; else searchingTravelExpert">
    @if (portalLead.flightRequest) {
      @let options = portalLead?.flightRequest?.publishedOptions?.edges | extractNodes;
      @if (options?.length) {
        <flight-info
          (back)="goBack()"
          [showBack]="!!user"
          [portalLead]="portalLead"
          class="mx-4 mx-md-0 flight-info"
        />

        <hr class="d-md-none mt-4" />

        <referral-credit-banner
          [referralCredit]="portalLead.referralCredit"
          bookingWindowLabel="3 months"
        />

        <div class="p-4 p-md-0 pt-md-8 pb-md-5 content">
          @for (option of options; track option.portalLink; let first = $first) {
            <portal-option
              (requestToBook)="requestToBook(option)"
              [option]="option"
              [portalLead]="portalLead"
              [isLeastExpensive]="getOptionSoldAmount(option) === leastExpensiveSoldAmount"
              [portalLink]="state.portalLink"
              [withHiddenFlightsV2]="withHiddenFlightsV2"
              [isSubmitting]="submittingPortalLink === option.portalLink"
              [ngClass]="{ 'mt-3 mt-md-8': !first }"
              data-id="option"
              attr.track-scroll="{
                'event_name': '{{ PortalTrackingEvents.quoteOverviewSeen }}',
                'lead_portal_link': '{{ state.portalLink }}',
                'option_portal_link': '{{ option.portalLink }}'
              }"
            />
          }

          <need-help-card [salesAgent]="portalLead.salesAgent" class="mt-3 mt-md-8" />
        </div>
      } @else {
        <empty-lead [showBack]="!!user" [lead]="portalLead" />
      }
    } @else {
      <ng-container *ngTemplateOutlet="travelExpertInfo" />
    }
  </ng-container>

  <ng-template #searchingTravelExpert>
    <div class="my-4 my-md-8">
      <searching-for-a-travel-expert class="mt-4 mt-md-8" />
    </div>
  </ng-template>

  <ng-template #travelExpertInfo>
    @if (portalLead.isQuickquote) {
      @if (portalLead.hasNotes) {
        <div class="d-flex flex-column flex-md-row align-items-center m-4 my-md-10">
          @if (selectedFeedbackOption === GoogleFlightsFeedbackOptionEnum.TOO_EXPENSIVE) {
            <img src="assets/images/bars.webp" alt="bars" width="300" height="300" />

            <div class="screen d-flex flex-column">
              <h1 class="semi-bold">Thanks for checking with us</h1>

              <p class="mt-2">
                Current Business Class fares for this route start in this range. Prices change
                often, so feel free to check back — we update deals weekly.
              </p>
            </div>
          } @else {
            <img src="assets/images/done.webp" alt="done" width="300" height="300" />

            <div class="screen d-flex flex-column">
              <h1 class="semi-bold">Thanks — we’ve got your request</h1>

              <h3 class="semi-bold mt-6">What happens next</h3>

              <div class="items mt-3">
                <img
                  src="/assets/icons/support_agent.svg"
                  alt="support_agent"
                  width="20"
                  height="20"
                />

                <div class="d-flex flex-column">
                  <p>
                    A travel expert reviews your feedback and searches for special Business Class
                    fares that aren’t available online
                  </p>

                  @if (showAgentDetails) {
                    <div class="d-flex align-items-center g-3 mt-2">
                      <img
                        [src]="portalLead.salesAgent.picture || 'assets/icons/avatar.svg'"
                        alt="user"
                        class="picture"
                      />

                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center">
                          <p data-id="fullname">{{ portalLead.salesAgent.fullName }}</p>

                          <ds-dot-separator class="mx-1" />

                          <p>your travel expert</p>
                        </div>

                        <div class="d-flex align-items-center mt-1 nowrap flex-wrap">
                          <p data-id="deals">{{ portalLead.salesAgent.deals }}+ trips planned</p>

                          <ds-dot-separator class="mx-1" />

                          <p data-id="savings">
                            {{ portalLead.salesAgent.avgSavings | portalCurrency }} average savings
                          </p>
                        </div>
                      </div>
                    </div>
                  }

                  <div
                    (click)="showAgentDetails = !showAgentDetails"
                    class="d-flex align-items-center g-1 cursor-pointer mt-2"
                  >
                    <p class="text-lightblue-600">About your travel expert</p>

                    <img
                      [class.rotated]="showAgentDetails"
                      src="assets/icons/keyboard_arrow_down.svg"
                      alt="keyboard_arrow_down"
                      width="20"
                      height="20"
                    />
                  </div>
                </div>

                <img src="/assets/icons/timer.svg" alt="timer" width="20" height="20" />

                <p>Usually within a few business hours</p>
              </div>
            </div>
          }
        </div>
      } @else {
        @let flightOption = flightOption$ | async;
        @if (loadedFlightOption) {
          @if (flightOption) {
            <travel-expert-info-quick-form
              (submitQuickquote)="submitQuickquote($event)"
              [portalLead]="portalLead"
              [flightOption]="flightOption"
            />
          } @else {
            <travel-expert-info [portalLead]="portalLead" />
          }
        } @else {
          <div class="d-flex flex-column g-4 p-4 p-md-0 pb-md-4">
            <ds-skeleton [width]="240" [height]="96" />
            <ds-skeleton [width]="200" [height]="50" />
            <ds-skeleton class="w-100" [height]="50" />
            <ds-skeleton class="w-100" [height]="50" />
          </div>
        }
      }
    } @else {
      <travel-expert-info [portalLead]="portalLead" />
    }
  </ng-template>
</ng-container>
